/* DSL Reddit Pixel events */
(function(){
  function ready(cb){ var iv = setInterval(function(){ if (window.rdt) { clearInterval(iv); cb(); } }, 200); setTimeout(function(){ clearInterval(iv); }, 10000); }
  ready(function(){
    var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
    if (c && c.marketing === false) return;
    if (location.pathname.indexOf("/products/") === 0) rdt("track", "ViewContent");
    document.addEventListener("dsl:cart:add", function(e){
      var d = e.detail || {};
      rdt("track", "AddToCart", {value: (d.price||0)/100, currency: "EUR"});
    });
  });
})();